<template>
  <div class="container">

    <div class="columns">

      <!-- MAIN CONTENT -->
      <div class="column col-10">
        <span v-if="errMsg" class="label label-error">{{errMsg}}</span>

        <form class="form-horizontal">
          <div class="form-group">
            <div class="col-3 col-sm-12">
              <label class="form-label">Name</label>
            </div>
            <div class="col-4 col-sm-12">
              <input class="form-input" type="text" v-model="template.name">
            </div>
          </div>
          <div class="form-group">
            <div class="col-3 col-sm-12">
              <label class="form-label">File id</label>
            </div>
            <div class="col-4 col-sm-12">
              <input class="form-input" type="text" v-model="template.fileId">
            </div>
          </div>
        </form>

        <templateSection v-for="(s, i) in template.sections" v-bind:key="i"
                         v-on:delete="removeSec(i)"
                         v-on:moveUp="moveSec(i, -1)"
                         v-on:moveDown="moveSec(i, 1)"
                         :section="s"
                         style="margin-bottom:10px;">
        </templateSection>
      </div>

      <!-- SIDEBAR -->
      <div class="column col-2">
        <div class="bg-secondary docs-block">
          <button v-if="template.fileId" @click="viewTemplate" class="btn btn-block btn-side">View Template</button>
          <button v-if="template._id" @click="del" class="btn btn-block btn-side">Delete Template</button>
          <button @click="addSection" class="btn btn-block btn-side">Add Section</button>
          <button @click="save" class="btn btn-block btn-side">Save</button>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import axios from 'axios'
import templateSection from '@/components/docs/templateSection'
import { bus } from '@/components/bus.js'

export default {
  name: 'edit_template',
  props: {
    new: String, // should be "true" if making a new template
    id: String    // template id OR matter type id if new === "true"
  },
  components: {
    templateSection
  },
  data () {
    return {
      isNew: false,
      errMsg: '',
      template: {
        _id: null,
        name: 'New Template',
        matter_type: this.id,
        fileId: '',
        sections: []
      }
    }
  },
  created: function () {
    this.$root.$data.pageTitle = 'Edit Template'
    this.isNew = this.new === 'true'
    if (!this.isNew) {
      axios.get('/api/docs/template/' + this.id).then(res => {
        if (res.status === 200) {
          this.template = res.data
        }
      }).catch(e => { console.log(e.response.data) })
    }
  },
  mounted () {
    bus.$emit('in_editor', true) // inform the menu
  },
  destroyed () {
    bus.$emit('in_editor', false)
  },
  methods: {
    addSection () {
      this.template.sections.push({
        name: 'section_name',
        pretty_name: 'Section name',
        display: false,
        fields: [{
          name: 'name',
          tag: '{{tag}}'
        }]
        // sections: []
      })
    },
    removeSec (i) {
      this.template.sections.splice(i, 1)
    },
    moveSec (i, dir) {
      this.movePosition(this.template.sections, i, dir)
    },
    save () {
      if (!this.template._id) {
        axios.post('/api/docs/newtemplate', this.template)
        .then(res => {
          if (res.status === 200) {
            console.log(res.data)
            this.template._id = res.data._id
          }
        })
        .catch(e => { this.errMsg = e.response.data })
      } else {
        axios.post('/api/docs/savetemplate', this.template)
        .catch(e => {
          this.errMsg = e.response.data
        })
      }
    },
    del () {
      axios.post('/api/docs/deletetemplate/' + this.template._id).then(res => {
        if (res.status === 200) {
          this.$router.go(-1)
        }
      })
    },
    movePosition (arr, i, dir) {
      // Move an element in an array
      if (dir === -1 && i === 0) return
      if (dir === 1 && i >= arr.length - 1) return
      var s = arr[i]
      var temp = arr[i + dir]
      if (dir === -1) {
        arr.splice(i - 1, 2, s, temp)
      } else {
        arr.splice(i, 2, temp, s)
      }
    },
    viewTemplate () {
      window.open('https://docs.google.com/document/d/' + this.template.fileId + '/edit', '_blank')
    }
  }
}
</script>

<style scoped>
.btn-side {
  margin-bottom:5px;
}
</style>



// WEBPACK FOOTER //
// edit_template.vue?05f8f688